import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SidebarLogo from '../../../../assets/images/munuLogo4x.png';
import sidebarClose from '../../../../assets/images/sidebar_close.png';
import { useOidc } from "@axa-fr/react-oidc";
import PersonalInfo from '../../../../assets/images/user.png';
import CardServices from '../../../../assets/images/card_services.png';
import Accounts from '../../../../assets/images/accounts.png';
import Security from '../../../../assets/images/security.png';
import Documents from '../../../../assets/images/documents.png';
import Settings from '../../../../assets/images/Settings.png';
import Helpcircle from '../../../../assets/images/help-circle.png';
import Logout from '../../../../assets/images/log-out.png';
import dot from '../../../../assets/images/Radial Fill.png';
import KudzuPluseLogo from '../../../../assets/kudzu-plus-images/KudzuPluseLogo.png';
import LogokBlue from "../../../../assets/images/LogoKLIghtBlue.png"
import rootReducer from '../../../../Redux/reducers'; // Import your rootReducer from the Redux reducer file
import { createStore } from 'redux';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { GetApiHeadersWithBearer, GetRequest, PostRequest, endSessionGetRequest } from '../../../../network/NetworkUtils';
import { appTheme, fetchConfigarationData, getUserMembership, retrieveData, showKudzuPlusPrompt } from '../../../../helpers/utils/Utils';
import { ACCEPT_E_SIGN_AGGREMENT, COVERED_BY_KUDZU, GET_ESIGN_AGREEMENT, GET_ESIGN_STATUS, GET_USER_PORFIE_INFO, SAVINGS_HABIT, SPENDING_ALERT, STATUS_SUCCESS_CODE, VALIDATE_AUTH_USER, END_SESSION } from "../../../../network/URLConstants";
import { convertTimestamp, clearStorageExceptKey, modifyHtmlForNavigation, useNotificationNavigation } from '../../../../utils';
import { useKeyDown } from '../../../../hooks/useKeyDown';
import logFirebaseEvents from "../../../LogFirebaseEvents/index"
import MemnershipEnrollmentScreens from '../../../../kudzu_plus/components/membershipEnrollmentScreens';
import Cookies from 'js-cookie';
import TourGuide from '../../../CustomComponents/ToolTipTour';
import KudzuLogo from '../../../../assets/kudzu-plus-images/K-plus-logo.png'
// import SideBarTour from '../../../SideBarTour';

const appConfigData = await fetchConfigarationData();

// const appConfigData = await fetchConfigarationData();

const Sidebar = ({ closeSidebar, notifications , onAction}) => {
    const { logout } = useOidc();
    const appConfigData = useSelector(state => state.appConfigData);
    const store = createStore(rootReducer);
    const navigate = useNavigate();
    const notificationNavigation = useNotificationNavigation();
    const dispatch = useDispatch();
    const location = useLocation()


    const { t } = useTranslation();
    const accessTokenToApi = useSelector(state => state.accessToken);
    const savingsCardAvailable = useSelector(state => state.savingsAccontAvailable);
    const savingsNewClicked = useSelector(state => state.savingsNewClicked);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const isShowKudzuPlusPrompt = showKudzuPlusPrompt(loggedResponse)
    const isTransferMoneyFeatureEnabled = loggedResponse?.IsTransferMoneyFeatureEnabled === true;
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue)
    const isB2c = useSelector(state => state.preferredIdentity);
    const userMembershipData = getUserMembership(loggedResponse)
    const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);
    const [isSidemenuDismissed, setIsSidemenuDismissed] = useState(false);
    // const isSideBarOpenVal = useSelector((state) => state?.isSideBarOpen);
    const SideBarStatus = useSelector(state => state.isSideBarOpen);
    const [openSideBar, setOpenSideBar] = useState(false);
    const[toolTipRun, setToolTipRun] = useState(false);
    const smiOneTrue = useSelector((state) => state?.smiOneAccountTrue);
    const limitRef = useRef(0);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const cbkInlcudesCheck = notifications.Content;

    
    const stepIndex = useSelector((state) => state?.SidebartoolTipstepIndex); 
    
    const homePath = location.pathname === '/Home';

    useEffect(() => {
        if(cards && smiOneTrue){
        const productTourTooltipValue = `sidebarTourTooltip${cards[0].CardKey}`;
            const savingsNewClicked = Cookies.get(productTourTooltipValue);
            if(!savingsNewClicked){       setToolTipRun(false);
        setTimeout(() => setToolTipRun(true), 100);
            }
        } 
      }, [window.location.pathname]);

        useEffect(() => {
            if(cards && smiOneTrue){
            const productTourTooltipValue = `sidebarTourTooltip${cards[0].CardKey}`;
            const savingsNewClicked = Cookies.get(productTourTooltipValue);
            if(!savingsNewClicked) {
                setToolTipRun(false);
          setTimeout(() => setToolTipRun(true), 1500);
            }
        }
          
        },[SideBarStatus]);

        useEffect (()=>{
            if(cards && smiOneTrue){
                const productTourTooltipValue = `sidebarTourTooltip${cards[0].CardKey}`;
                const savingsNewClicked = Cookies.get(productTourTooltipValue);
                if(!savingsNewClicked) {
                    setToolTipRun(false);
                    setTimeout(() => setToolTipRun(true), 1100);
                } 
            }
        },[window.innerWidth])
      

    useEffect(()=>{
        if(cards && cards.length > 0 && smiOneTrue) {
            if(smiOneTrue) {
                limitRef.current = 0;
          
            const scrollStep = 1;
            const scrollAutomatically = () => {
              if (limitRef.current < -2) {
                  window.scrollBy({
                    top: scrollStep,
                    left: 0,
                    behavior: "smooth",
                });
                limitRef.current -= 1;
              } else {
                clearInterval(interval);
              }
            };
            const interval = setInterval(scrollAutomatically, 100);
          
            return () => clearInterval(interval);
            }
            const productTourTooltipValue = `sidebarTourTooltip${cards[0].CardKey}`;
            const savingsNewClicked = Cookies.get(productTourTooltipValue);
            if(!savingsNewClicked || savingsNewClicked === undefined){
                setToolTipRun(true);
            } else {
                setToolTipRun(false)
            }
        }
    })

    const handleNextStep = () => {
        if (stepIndex === steps.length - 1) {
                if (cards && cards.length > 0) {
                    const productTourTooltipValue = `sidebarTourTooltip${cards[0].CardKey}`;
                    Cookies.set(productTourTooltipValue, true, { expires: 1825 }); 
                }
                setToolTipRun(false);
              } else {
                dispatch({
                  type: "SIDEBAR_TOOLTIP_TOUR_NEXT_STEP",
                  payload: { SidebartoolTipstepIndex: stepIndex + 1 },
            });
        }
    };

    useEffect(() => {
        setOpenSideBar(SideBarStatus);
        if(cards && smiOneTrue){
            const productTourTooltipValue = `sidebarTourTooltip${cards[0].CardKey}`;
            const savingsNewClicked = Cookies.get(productTourTooltipValue);
            const navbars  = document.querySelector(".nav-bar");
            const sidebarContent = document.querySelector(".Sidebar-content")
            const insights = document.querySelector(".insights")
            const cardContent = document.querySelector(".animate__animated")

        if (toolTipRun  && SideBarStatus && !savingsNewClicked) {
            if(toolTipRun){
                document.body.style.overflow = "hidden";
                if(cardContent) cardContent.style.pointerEvents = "none";
                if(navbars) navbars.style.pointerEvents = "none";
                if(sidebarContent) sidebarContent.style.pointerEvents = "none"
            }
          } else {
            if(!toolTipRun){
                document.body.style.overflow="";
                if(cardContent) cardContent.style.pointerEvents = "";
                if(navbars) navbars.style.pointerEvents = "";
                if(sidebarContent) sidebarContent.style.pointerEvents = "";
            }
          }
        }
      
      }, [SideBarStatus, toolTipRun, handleNextStep]);
      
      const steps = [
        {
          target: ".personal-info-tooltip",
          content: (
            <div className='font-hanken-grotesk text-[14px] font-[700]'>
              <p className="text-left">View and manage your personal information here.</p>
              <div className="flex justify-end mt-[10px]">
                <button type="button" className="underline" onClick={handleNextStep} style={buttonStyle}>
                  {t('ok_got_it')}
                </button>
              </div>
            </div>
          ),
          placement: "left",
          disableBeacon: true,
        },
          {
            target: ".card-servi",
            content: (
              <div className='font-hanken-grotesk text-[14px] font-[700]'>
                <p className="text-left">View and manage your smiONE Card here.</p>
                <div className="flex justify-end mt-[10px]">
                  <button type="button" className="underline" onClick={handleNextStep} style={buttonStyle}>
                    {t('ok_got_it')}
                  </button>
                </div>
              </div>
            ),
            placement: "left",
            disableBeacon: true,
          },
          {
            target: ".acc-service",
            content: (
              <div className='font-hanken-grotesk text-[14px] font-[700]'>
                <p className="text-left">View your smiONE Card account details, add funds, and transfer money here.</p>
                <div className="flex justify-end mt-[10px]">
                  <button type="button" className="underline" onClick={handleNextStep} style={buttonStyle}>
                    {t('ok_got_it')}
                  </button>
                </div>
              </div>
            ),
            placement: "left",
            disableBeacon: true,
          },
          {
            target: ".personal-doc",
            content: (
              <div className='font-hanken-grotesk text-[14px] font-[700]'>
                <p className="text-left">View, manage, and download your smiONE Card statements and other important documents here.</p>
                <div className="flex justify-end mt-[10px]">
                  <button type="button" className="underline" onClick={handleNextStep} style={buttonStyle}>
                    {t('ok_got_it')}
                  </button>
                </div>
              </div>
            ),
            placement: "left",
            disableBeacon: true,
          },
          {
            target: ".settings-set",
            content: (
              <div className='font-hanken-grotesk text-[14px] font-[700]'>
                <p className="text-left">Manage your app settings and configure notification preferences here.</p>
                <div className="flex justify-end mt-[10px]">
                  <button type="button" className="underline" onClick={handleNextStep} style={buttonStyle}>
                    {t('ok_got_it')}
                  </button>
                </div>
              </div>
            ),
            placement: "left",
            disableBeacon: true,
          },
    
        ]


    //logout call for resetting session
    
    const handleLogout = async () => {
        debugger
        sessionStorage.removeItem('plusModalClosedHome');
        // if (!global.isLoggedIn) {
        //     return
        // }
        global.isLoggedIn = false
        global.accessTokenReload = accessTokenToApi
        // logout()
        logoutManually();
    };

    const logoutManually = async () => {
        if (global.accessTokenReload != '' && global.accessTokenReload != undefined) {
            var url = END_SESSION(isB2c, appConfigData.AUTH_URL, appConfigData.B2C_END_SESSION_URL, appConfigData.CLIENT_ID, global.accessTokenReload, appConfigData.POST_LOGOUT_REDIRECT_URI);
            window.location.replace(url);
            store.dispatch({ type: 'LOGOUT' });
        }

        // console.log("modified url is ",url);
        // var response = await endSessionGetRequest(url, headers);
        // var parsedResponse = JSON.parse(response);
        // console.log("parsed response is ",parsedResponse);
        // if (parsedResponse.ResponseCode == STATUS_SUCCESS_CODE) {
        //   return true;
        // } else {
        //     var arrMessages = parsedResponse.Messages;
        //     var message = arrMessages[0];
        //     var displayText = message.DisplayText;
        //     return false;
        // }
    }

    // Function to handle navigation
    const handleNavigate = (path) => {
        navigate(path);
        closeSidebar(); // Optionally, close the sidebar after navigation
    };

    const handleNotificationClick = () => {
        if (!notifications.length) navigate('/notifications')
    }

    useKeyDown(() => {
        closeSidebar();
    }, ["Escape"])

    const handleNavigateToExtendFlow = () => {
        const currentPath = { currentPathFromStore: location.pathname };
        dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
        setShowCarouselScreensShow((prev) => !prev);
        // showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('./../../assets/kudzu-plus-images/kudzu-plus-logo.png') ,"",true,"#262B3A",t('first_three_months_charged_automatically'),true,'',false,false,true,true);
        const data = { kudzuFlowFrom: "fromExtendFlow" };
        dispatch({ type: 'KUDZU_PLUS_FROM', payload: data }); 
    } 

    useEffect(() => {  
        if (cards && cards.length > 0) {
            const SidemenuDismissGet = `SidemenuDismiss${cards[0].CardKey}`;
            const sidemenuShown = Cookies.get(SidemenuDismissGet); 
            setIsSidemenuDismissed(sidemenuShown);
        }
    }, []);


    const handleDismiss = () => {
        if (!cards || cards.length === 0) return;
        const SidemenuDismiss = `SidemenuDismiss${cards[0].CardKey}`; 
        Cookies.set(SidemenuDismiss, 'true', { expires: 1825 });
        setIsSidemenuDismissed(true);
    };
    const extendFlowCloseCallbackFunction = (val) => {
        setShowCarouselScreensShow(val)
    }


    const applyDynamicStyles = () => {
            // Target any element with "notification-title" class
            const notificationTitleElements = document.querySelectorAll(".notification-title");
         
            if (notificationTitleElements.length > 0) {
              notificationTitleElements.forEach((el) => {
                // el.style.color = "var(--notificationtextheadingsColor)";
                el.style.fontSize = "26px";
                el.style.fontWeight = "600";
                el.style.marginBottom = "8px";
                el.style.lineHeight = "1.5";
                el.style.fontFamily = "'Hanken Grotesk', sans-serif";
              });
            }
    
            const notificationText = document.querySelectorAll(".notification-text");
         
            if (notificationText.length > 0) {
              notificationText.forEach((el) => {
                // el.style.color = "var(--notificationtextheadingsColor)";
                el.style.marginBottom = "14px";
               
              });
            }
    
        const notificationButtons = document.querySelectorAll(".notification-button");
        if (notificationButtons.length > 0) {
            notificationButtons.forEach((btn) => {
                btn.style.backgroundColor = "#2a52be";
                btn.style.color = "#ffffff";
                btn.style.border = "none";
                btn.style.padding = "10px 16px";
                btn.style.borderRadius = "4px";
                btn.style.cursor = "pointer";
                btn.style.fontSize = "8px";
                if(homePath){
                    btn.style.marginLeft = "";
                }else{
                    btn.style.marginLeft = "";
                }
                //btn.style.marginLeft = "200px";
            });
        }

            const notificationFootNote = document.querySelectorAll(".notification-footnote");
          
            if (notificationFootNote.length > 0) {
              notificationFootNote.forEach((el) => {
                // el.style.color = "var(--notificationtextheadingsColor)";
                el.style.fontSize = "14px";
               
              });
            }

             const notificationLink = document.querySelectorAll(".notification-link");
          
            if (notificationLink.length > 0) {
              notificationLink.forEach((el) => {
                // el.style.color = "var(--notificationtextheadingsColor)";
               el.style.textDecoration = "underline";
               
              });
            }
        };
    
    
        useEffect(() => {
            // Apply styles after component mounts and content is rendered
            applyDynamicStyles();
        }, []);
    
    

    return (
        <>
            {showCarouselScreenShow &&
                <MemnershipEnrollmentScreens extendFlowCloseCallbackFunction = {extendFlowCloseCallbackFunction}  />
            }
            <div className='Sidebar  max-h-screen min-h-screen
            bg-[var(--sidebar-bg)] text-white overflow-y-scroll overflow-x-hidden w-full transition-all duration-1000'>
                {/* <div className='Sidebar fixed right-0 top-0 max-h-screen min-h-screen h transition-all duration-1000 justify-end
            md:w-[17rem] sm:w-[15rem] w-full bg-[#28314F] text-white overflow-y-scroll z-50'> */}
                <div className="pb-8 px-8 pt-6 Sidebar-content">
                    <div className='flex flex-row justify-between items-center'>
                        <img src={appThemeData.sideBarLogo} className='lg:w-[80px] lg:h-[20px] md:w-[80px] md:h-[20px] sm:w-[54px] sm:h-[14px] w-[67px] h-[18px]' alt={t('kudzu_logo_alt')} />
                        {/* <img src={SidebarLogo} className='lg:w-[80px] lg:h-[45px] md:w-[66px] md:h-[40px] sm:w-[60px] sm:h-[30px]' /> */}
                        <button type="button" onClick={closeSidebar} className='lg:w-[48px] lg:h-[48px] md:w-[43px] md:h-[43px] sm:w-[38px] sm:h-[38px] cursor-pointer bg-transparent border-0 p-0' aria-label={t('close_sidebar_alt')}>
                            <img src={sidebarClose} className='w-full h-full' alt="" />
                        </button>
                    </div>
 
                    {(userMembershipData?.extendTrial && !isSidemenuDismissed) &&
                        <div className='pt-6 pl-1 md:pr-[27px] pr-[15px] border-b-[3px]
                     border-[var(--sidebar-border)] pb-12'>

                            <img src={KudzuLogo} alt='KudzuPluseLogo' className='w-[150px] h-[120px] ml-[-15px] mb-[15px]' />

                            <div className='flex flex-col gap-6'>
                                <p className='font-serif-pro text-white'>{t('kudzu+_Membership_Expires')}<span className="bottomBorder">{" " + userMembershipData?.extendTrial ? userMembershipData?.daysRemaining : ""}</span>{" "}{t('days')}.</p>
                                <p className='sm:text-[12px] text-[13px]
                        font-hanken-grotesk'>{t('Keep_features_and_benefits')}</p>
                                <div className='sm:text-[12px] text-[13px] font-[600] leading-[20px]
                         font-hanken-grotesk cursor-pointer flex gap-10'>
                                    <button type='button' className='text-[#94C3E8] underline' onClick={handleNavigateToExtendFlow}>{t('extend_kudzu+')}</button>
                                    <button type='button' className='text-[#78b3f9] underline' onClick={handleDismiss}>{t('dismiss')}</button>
                                </div>
                            </div>
                        </div>
                    }


                    <div className='sm:hidden block'>
                        <div className='lg:pt-[4.5rem] md:pt-[3.5rem] sm:pt-[2.5rem]
                     pt-[2rem] flex justify-between w-full'>
                            <span className='font-[600] md:text-[15px] sm:text-[13px]
                             text-[16px] leading-[23px]'>{t('Menu')}</span>
                        </div>

                        <ul className='pt-8 border-[var(--sidebar-border)] border-b-[3px]'>
                            <li className='flex pb-10'>
                                <Link to="/Spending" onClick={closeSidebar}>

                                    <span className='font-[700]  md:text-[15px] sm:text-[13px] 
                                text-[16px] leading-[16px] font-hanken-grotesk sm:ml-2 ml-6'>
                                        {t('NavbarChecking')}</span>
                                </Link>
                            </li>
                            <li className='flex pb-10'>
                                <Link to="/Savings" onClick={closeSidebar}>

                                    <span className='font-[700] md:text-[15px] sm:text-[13px]
                                     text-[16px] leading-[16px] font-hanken-grotesk sm:ml-2 ml-6'>
                                        {t('NavbarSavings')}</span>
                                </Link>
                            </li>

                            <li className='flex pb-10'>
                                <Link to="/PayPerks" onClick={closeSidebar}>

                                    <span className='font-[700]  md:text-[15px] sm:text-[13px]
                                     text-[16px] leading-[16px] font-hanken-grotesk sm:ml-2 ml-6'>
                                        {t('NavbarPerks')}</span>
                                </Link>
                            </li>

                            <li className='flex pb-10'>
                                <Link
                                    //   to="/Climb"
                                    to={isShowKudzuPlusPrompt ? "/Toolkit/ToolkitMenu" : "/Toolkit/ToolkitMenu"}
                                    state={{ isClimbShowPopups: true }}
                                    onClick={closeSidebar}>

                                    <span className='font-[700]  md:text-[15px] sm:text-[13px]
                                     text-[16px] leading-[16px] font-hanken-grotesk sm:ml-2 ml-6'>{t('Toolkit')}</span>
                                </Link>
                            </li>
                            <li className='flex pb-10'>
                                <Link to='/Help/FAQ' onClick={closeSidebar}>

                                    <span className='font-[700]  md:text-[15px] sm:text-[13px]
                                     text-[16px] leading-[16px] font-hanken-grotesk sm:ml-2 ml-6'>{t('helpText')}</span>
                                </Link>
                            </li>
                        </ul>
                    </div>


                    <div className='md:pt-[3rem] pl-1 sm:pt-[2.5rem] pt-[2rem] flex justify-between w-full'>
                        {!notifications.length ? (
                            <Link to="/notifications" className={`font-[600] md:text-[15px] sm:text-[13px] text-[16px] leading-[23px] cursor-pointer text-left text-white no-underline`}>{t('Notifications')}</Link>
                        ) : (
                            <span className="font-[600] md:text-[15px] sm:text-[13px] text-[16px] leading-[23px]">{t('Notifications')}</span>
                        )}
                        {(notifications.length > 0) &&
                            <Link to="/notifications" className='sm:text-[12px] text-[13px] text-[#94C3E8] font-[600] leading-[20px] font-hanken-grotesk cursor-pointer underline'>
                                {t('viewAll')}
                            </Link>
                        }
                    </div>

                    {(notifications.length > 0) &&
                        notifications.map((notification) => {
                            return (
                                
                                <ul className='pt-6 pl-1 md:pr-[27px] pr-[15px] border-b-[3px] border-[var(--sidebar-border)] pb-4'>
                                    {/* <ul className='pt-6 md:px-[27px] px-[15px] border-b-2 border-[#314169] pb-4'> */}
                                    <li className=" flex flex-row sm:gap-5 gap-6 font-[500] md:text-[14px] text-[12px] leading-[21px] font-hanken-grotesk">
                                        {/* <li className="marker:text-[#2965FB] marker:text-[20px] font-[500] md:text-[14px] text-[12px] leading-[21px] list-disc font-hanken-grotesk"> */}
                                        <img src={notification.Content.includes('Covered') ? appThemeData.sideBarDotForCbk : appThemeData.sideBarDot} alt='' className={notification.Content.includes('Covered') ? `w-[9px] h-[9px] mt-1` :`w-[8px] h-[8px] mt-1`} />
                                        <div>


                                            <div
                                             className='break-words whitespace-normal w-[80%]'
                                                dangerouslySetInnerHTML={{ __html: modifyHtmlForNavigation(notification.Content, '#78b3f9') }}
                                                 onClick={(e) => {
                                            if (e.target.tagName === 'A') {
                                                 e.preventDefault();
                                                e.stopPropagation();
                                                const href = e.target.getAttribute('href');
                                                dispatch({
                                                     type: 'CBK_TRANSACTIONS',
                                                    payload: {
                                                      notifications: [{ ...notification }]
                                                    }
                                                  });
                                              if (href && (href.startsWith('http://') || href.startsWith('https://'))) {
                                                window.open(href, '_blank', 'noopener,noreferrer');
                                              } else if (href && (href === "yes-replace" || href === 'no-replace' || href === 'yes-unblock' || href === 'no-unblock')) {
                                                let action = null;
                                                if (href === "yes-replace") {
                                                  action = notification.YesAction;
                                                } else if (href === 'no-replace') {
                                                  action = notification.NoAction;
                                                } else if (href === 'yes-unblock') {
                                                  action = notification.YesAction;
                                                }
                                                else if (href === 'no-unblock') {
                                                  action = notification.NoAction;
                                                }
                                                if (action && action.CallbackURL) {
                                                  if (onAction) {
                                                    onAction(action.CallbackURL);
                                                  }
                                                }
                                              }
                                              else {
                                                notificationNavigation(href, e);
                                              }
                                            }

                                        }}
                                            />
                                            <div className=' flex flex-row gap-2 mt-2 justify-start items-center'>
                                                {notification.AlertTypeCode === "WRN" &&
                                                    <div className=' bg-footer rounded-full px-2 py-2 '>
                                                        <p className='font-hanken-grotesk font-[700] text-[10px] leading-[15px] lg:text-[12px] lg:leading-[18px] text-white'>
                                                            {t("important")}
                                                        </p>

                                                    </div>

                                                }
                                                <p className='text-[#94C3E8] md:text-[12px] 
                                            sm:text-[10px] text-[11px] font-[600] font-hanken-grotesk '>{convertTimestamp(notification.CreatedDateTime)}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                            )
                        })
                    }

                    {(notifications.length === 0) &&
                        <div className=" w-full flex flex-row justify-start gap-4 mt-6 border-b-[3px] border-[var(--sidebar-border)] pb-8">
                            <div>
                                <img src={appThemeData.logokBlueIcon} alt="" className=' opacity-50 pt-1' />
                            </div>
                            <div className="flex flex-col justify-start ">
                                <p className='font-hanken-grotesk font-[500] text-[13px] leading-[19px] sm:text-[12px] sm:leading-[18px] text-[var(--personal-info-border)] opacity-50'>{t("no_notification_status1")}</p>
                                <p className='font-hanken-grotesk font-[500] text-[13px] leading-[19px] sm:text-[12px] sm:leading-[18px] text-[var(--personal-info-border)] opacity-50'>{t("no_notification_status2")}</p>
                            </div>
                        </div>
                    }

                    


                    <ul className='pt-8 border-[var(--sidebar-border)]  border-b-[3px]'>

                        <li className='flex pb-10'>
                            <Link to="/PersonalInformation" onClick={() => { closeSidebar(); logFirebaseEvents("Menu", "Personal_Info_Clicked", "Personal_Info_Clicked", "", ""); }}>
                                <img src={appThemeData.personalIfoIcon} alt='' className='md:h-[17px] md:w-[17px] sm:w-[16px] sm:h-[16px] w-[18px] h-[18px] inline-flex' />
                                <span className='font-[700]  md:text-[15px] sm:text-[13px] text-[16px] leading-[16px] font-hanken-grotesk sm:ml-5 ml-6 personal-info-tooltip'>{t('Personal_Information')}</span>
                            </Link>
                        </li>
                        {isTransferMoneyFeatureEnabled && (
                            <li className='flex pb-10'>
                                <Link to="/ManageMoney" onClick={() => { closeSidebar(); logFirebaseEvents("Menu", "Manage_Money_Clicked", "Manage_Money_Clicked", "", ""); }}>
                                    <img src={appThemeData.manageMoneyIcon} alt='' className='md:w-[17px] w-[15px] md:h-[17px] h-[15px] inline-flex' />
                                    <span className='font-[700] md:text-[15px] sm:text-[13px] text-[16px] leading-[16px] font-hanken-grotesk sm:ml-5 ml-6'>{t('Manage_Money')}</span>
                                </Link>
                            </li>
                        )}
                        <li className='flex pb-10'>
                            <Link to="/CardServices" onClick={() => { closeSidebar(); logFirebaseEvents("Menu", "Card_Services_Clicked", "Card_Services_Clicked", "", ""); }}>
                                <img src={appThemeData.cardservicesIcon} alt='' className='w-[17px] h-[17px]  inline-flex' />
                                <span className='font-[700] md:text-[15px] sm:text-[13px] text-[16px] leading-[16px] font-hanken-grotesk sm:ml-5 ml-6 card-servi'>{t('Card_Services')}</span>
                            </Link>
                        </li>
 

                        {/* <li className='flex pb-10'>
                            <Link to="/AccountServices" onClick={closeSidebar}>
                                <img src={Accounts} alt='' className='md:w-[17px] w-[15px] md:h-[17px] h-[15px] inline-flex' />     
                                <span className='font-[700] md:text-[15px] sm:text-[13px] text-[16px] leading-[16px] font-hanken-grotesk sm:ml-2 ml-6'>{t('Account_Services')}</span> <div className="w-1 h-1 bg-blue-100 rounded-full mr-2"></div>
                            </Link>
                        </li> */}
                        <li className='flex items-center pb-10'>
                            <Link to="/AccountServices" onClick={() => { closeSidebar(); logFirebaseEvents("Menu", "Account_Services_Clicked", "Account_Services_Clicked", "", ""); }} className='flex items-center'>
                                <img src={appThemeData.accountsIcon} alt='' className='md:w-[17px] w-[15px] md:h-[17px] h-[15px] inline-flex' />
                                <span className='acc-service font-[700] md:text-[15px] sm:text-[13px] text-[16px] leading-[16px] font-hanken-grotesk sm:ml-5 ml-6'>
                                 {t('Account_Services')}
                                </span>
                                {(savingsCardAvailable == false && savingsNewClicked == false) && <div className="w-2 h-2 bg-[#94C3E8] rounded-full ml-4"></div>}
                            </Link>
                        </li>

                        <li className='flex pb-10'>
                            <Link to="/Security" onClick={() => { closeSidebar(); logFirebaseEvents("Menu", "Security_Clicked", "Security_Clicked", "", ""); }}>
                                <img src={appThemeData.securityIcon} alt='' className='md:w-[17px] w-[15px] md:h-[17px] h-[15px] inline-flex' />
                                <span className='font-[700]  md:text-[15px] sm:text-[13px] text-[16px] leading-[16px] font-hanken-grotesk sm:ml-5 ml-6'>{t('Security')}</span>
                            </Link>
                        </li>

                        <li className='flex pb-10'>
                            <Link to="/Documents" onClick={() => { closeSidebar(); logFirebaseEvents("Menu", "Documents_Clicked", "Documents_Clicked", "", ""); }}>
                                <img src={appThemeData.documentsIcon} alt='' className='md:w-[17px] w-[15px] md:h-[17px] h-[15px] inline-flex' />
                                <span className='font-[700]  md:text-[15px] sm:text-[13px] text-[16px] leading-[16px] font-hanken-grotesk sm:ml-5 ml-6 personal-doc'>{t('Documents')}</span>
                            </Link>
                        </li>

                        <li className='flex pb-10'>
                            <Link to="/Settings" onClick={() => { closeSidebar(); logFirebaseEvents("Menu", "Settings_Clicked", "Settings_Clicked", "", ""); }}>
                                <img src={appThemeData.settingsIcon} alt='' className='md:w-[17px] w-[15px] md:h-[17px] h-[15px] inline-flex' />
                                <span className='font-[700]  md:text-[15px] sm:text-[13px] text-[16px] leading-[16px] font-hanken-grotesk sm:ml-5 ml-6 settings-set'>{t('Settings')}</span>
                            </Link>
                        </li>

                        <li className='flex pb-10'>
                            <Link to="/Help" onClick={() => { closeSidebar(); logFirebaseEvents("Menu", "Help_Clicked", "Help_Clicked", "", ""); }}>
                                <img src={appThemeData.helpcircleIcon} alt='' className='md:w-[17px] w-[15px] md:h-[17px] h-[15px] inline-flex' />
                                <span className='font-[700]  md:text-[15px] sm:text-[13px] text-[15px] leading-[16px] font-hanken-grotesk sm:ml-5 ml-6'>{t('Help')}</span>
                            </Link>
                        </li>
                    </ul>

                    <ul className='pt-8 pb-4'>
                        <li className='flex'>
                            <button type="button" onClick={() => { handleLogout(); logFirebaseEvents("Menu", "LogOut_Clicked", "LogOut_Clicked", "", ""); }} className='bg-transparent border-0 p-0 text-left cursor-pointer flex items-center'>
                                <img src={appThemeData.logoutIcon} alt='' className='md:w-[17px] w-[15px] md:h-[17px] h-[15px] inline-flex' />
                                <span className='font-[700]  md:text-[15px] sm:text-[13px] text-[15px] leading-[16px] font-hanken-grotesk sm:ml-5 ml-6 text-white'>{t('log_out')}</span>
                            </button>
                        </li>
                    </ul>

                </div>
                { openSideBar && (
                <TourGuide
                joyRideId="fromSideBar"
                steps={steps}
                handleNextStep={handleNextStep}
                stepIndex={stepIndex}
                toolTipRun={toolTipRun}
                backgroundClr='#fff'
                textClr='rgb(41, 101, 251)'
                />
            )} 
                
            </div>  
        </>
    );
};

export default Sidebar;

const buttonStyle = {
    backgroundColor: "none",
    border: "none",
    cursor: "pointer",
    marginTop: "10px",
  };